import { BaseEntity } from './base.entity';
import { User } from './user.entity';
import {
  ActivityLevel,
  DayOfWeek,
  TimeSlot,
  TrainingLocation,
  TrainingObjective,
  SportSpecialty,
} from '../enum/profile.enum';
import { Transform, Type } from 'class-transformer';

export class Profile extends BaseEntity {
  height!: number;
  weight!: number;
  activityLevel!: ActivityLevel;
  sportActivityLevel!: ActivityLevel;
  availability!: DayOfWeek[];
  @Transform(
    ({ value }) => {
      if (Array.isArray(value)) {
        return {};
      }
      return value;
    },
    { toClassOnly: true }
  )
  availabilityHoursInDaysOfWeek!: Record<DayOfWeek, TimeSlot[]>;
  preferredLocations!: TrainingLocation[];
  objectives!: TrainingObjective[];
  specialties!: SportSpecialty[];
  @Type(() => User)
  user?: User;
  diplomaNumber!: string;

  // Reviews aggregation (from backend Profile)
  averageRating?: number; // moyenne arrondie, ex: 4.5
  reviewsCount?: number; // nombre d'avis
}
